import { DebitParams } from 'core/interfaces/DebitParams';
import { endpoints } from 'core/consts/endpoints';
import { getEFT } from './Common';

const { accounts } = endpoints;

export const getAccounts = (params: DebitParams) => getEFT(accounts, params);
